// components/StudentFilters.jsx

import React from "react";
import {
  Box,
  TextField,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
} from "@mui/material";

const StudentFilters = ({
  board,
  searchQuery,
  setSearchQuery,

  sscClassOptions,
  sscSelectedClass,
  setSscSelectedClass,

  sscSectionOptions,
  sscSelectedSection,
  setSscSelectedSection,

  interSelectedClass,
  setInterSelectedClass,

  selectedCourseType,
  setSelectedCourseType,

  courseOptions,

  interSelectedSection,
  setInterSelectedSection,

  interSectionOptions,

  isPrincipal,
  users,
  selectedUsers,
  setSelectedUsers,

  rightAction, // NEW: optional element rendered on the far right of this same row
}) => {
  return (
    <Box
      display="flex"
      mb={3}
      flexWrap="wrap"
      alignItems="center"
      gap={2}
    >
      <TextField
        label="Search"
        size="small"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />

      {board === "SSC" && (
        <>
          <FormControl size="small">
            <InputLabel>Class</InputLabel>
            <Select
              value={sscSelectedClass}
              label="Class"
              onChange={(e) =>
                setSscSelectedClass(e.target.value)
              }
            >
              {sscClassOptions.map((item) => (
                <MenuItem key={item} value={item}>
                  {item}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl size="small">
            <InputLabel>Section</InputLabel>
            <Select
              value={sscSelectedSection}
              label="Section"
              onChange={(e) =>
                setSscSelectedSection(e.target.value)
              }
            >
              {sscSectionOptions.map((item) => (
                <MenuItem key={item} value={item}>
                  {item}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </>
      )}

      {board === "INTERMEDIATE" && (
        <>
          <FormControl size="small">
            <InputLabel>Year</InputLabel>
            <Select
              value={interSelectedClass}
              label="Year"
              onChange={(e) =>
                setInterSelectedClass(e.target.value)
              }
            >
              <MenuItem value="Inter-1st-Year">
                Inter-1st-Year
              </MenuItem>
              <MenuItem value="Inter-2nd-Year">
                Inter-2nd-Year
              </MenuItem>
            </Select>
          </FormControl>

          <FormControl size="small">
            <InputLabel>Course</InputLabel>
            <Select
              value={selectedCourseType}
              label="Course"
              onChange={(e) =>
                setSelectedCourseType(e.target.value)
              }
            >
              {courseOptions.map((course) => (
                <MenuItem key={course} value={course}>
                  {course}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl size="small">
            <InputLabel>Section</InputLabel>
            <Select
              value={interSelectedSection}
              label="Section"
              onChange={(e) =>
                setInterSelectedSection(e.target.value)
              }
            >
              {interSectionOptions.map((section) => (
                <MenuItem key={section} value={section}>
                  {section}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </>
      )}

      {isPrincipal && (
        <FormControl
          size="small"
          sx={{
            width: 180,
          }}
        >
          <InputLabel>Select Admin</InputLabel>

          <Select
            value={selectedUsers}
            onChange={(e) => setSelectedUsers(e.target.value)}
            label="Select Admin"
          >
            {users.map((user) => (
              <MenuItem
                key={user.userId}
                value={user.userId}
              >
                {user.userId} - {user.firstName} {user.lastName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      {/* NEW: right-aligned slot — pushed to the far right of this same row via ml:auto */}
      {rightAction && (
        <Box sx={{ ml: "auto" }}>
          {rightAction}
        </Box>
      )}
    </Box>
  );
};

export default React.memo(StudentFilters);